"use strict";

exports.__esModule = true;
exports.TimelinePaginationField = TimelinePaginationField;
var _react = _interopRequireDefault(require("react"));
var _DefaultPageSize = require("../../Core/DataTable/Fields/DefaultPageSize");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelinePaginationField(props) {
  var setDefaultPageSize = props.setDefaultPageSize,
    defaultPageSize = props.defaultPageSize,
    _props$pageSizes = props.pageSizes,
    pageSizes = _props$pageSizes === void 0 ? [5, 25, 100, 250, 500] : _props$pageSizes;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_DefaultPageSize.DefaultPageSize, {
    setDefaultPageSize: setDefaultPageSize,
    pageSizes: pageSizes,
    defaultPageSize: defaultPageSize
  }));
}